export const GET_MEMBER_OVERDUE_LOANS_START =
  'GET_MEMBER_OVERDUE_LOANS_START';
export const GET_MEMBER_OVERDUE_LOANS_ERROR =
  'GET_MEMBER_OVERDUE_LOANS_ERROR';
export const GET_MEMBER_OVERDUE_LOANS_SUCCESS =
  'GET_MEMBER_OVERDUE_LOANS_SUCCESS';
